'use client';

import { useTranslation } from '@lichtblick/i18next';
import { Refresh } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';

import { Loading, StyledText } from '../Login.styles';

export const LoginSpinner = () => {
  const { t } = useTranslation('login');

  return (
    <>
      <Loading>
        <Refresh color="disabled" fontSize="large" height={100} />
      </Loading>
      <StyledText $variant={TextVariants.body.l}>{t('redirectAfterLogin')}</StyledText>
    </>
  );
};
